import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage, useIntl } from 'react-intl';
import { ProgressModal } from '../_DesignSystemWrappers/Modal';
import Loader from '../Loader';
import rcMessages from '../RCModal/messages';
import messages from './messages';

interface IAccessCommanderConnectingModalProps {
  open: boolean;
}

export default function AccessCommanderConnectingModal({ open }: IAccessCommanderConnectingModalProps) {
  const { formatMessage } = useIntl();

  return (
    <ProgressModal
      buttonColor="primary"
      onClose={() => {}}
      open={open}
      testId="acom-connecting-modal"
      title={formatMessage(messages.AccessCommanderConnectingModalTitle)}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          minHeight: 200,
        }}
      >
        <Typography component="p" sx={{ mb: 3 }}>
          <FormattedMessage {...rcMessages.rcModalWaitForConnection} />
        </Typography>
        <Loader alignItems="center" size={80} />
      </Box>
    </ProgressModal>
  );
}
